import { useState } from "react";
import axios from "axios";
import { Spin } from "antd";
import Navbar from "../../common/Navbar";
import Hero from "../../common/Hero";
import Footer from "../../common/Footer";
import BlogImage from "../../assests/images/terms222.jpg";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState({ sending: false, success: null, message: "" });

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Name is required";
    if (!form.email.trim()) e.email = "Email is required";
    else if (!/^\S+@\S+\.\S+$/.test(form.email)) e.email = "Invalid email";
    if (!form.subject.trim()) e.subject = "Subject is required";
    if (!form.message.trim()) e.message = "Message is required";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleChange = (k) => (ev) => setForm((s) => ({ ...s, [k]: ev.target.value }));

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    if (!validate()) return;

    setStatus({ sending: true, success: null, message: "" });

    try {
      const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "923177190178";

      const text = [
        `Name: ${form.name}`,
        `Email: ${form.email}`,
        `Subject: ${form.subject}`,
        `Message: ${form.message}`,
      ].join("\n");

      const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

      setTimeout(() => {
        window.open(url, "_blank");
        setStatus({ sending: false, success: true, message: "WhatsApp opened. Complete send in WhatsApp." });
        setForm({ name: "", email: "", subject: "", message: "" });
      }, 1200);
    } catch {
      setStatus({ sending: false, success: false, message: "Failed to open WhatsApp. Please try again." });
    }
  };

  const handleTextareaWheel = (e) => {
    const el = e.currentTarget;
    const delta = e.deltaY;
    const atTop = el.scrollTop === 0;
    const atBottom = Math.abs(el.scrollHeight - el.clientHeight - el.scrollTop) < 1;

    if (!(delta < 0 && atTop) && !(delta > 0 && atBottom)) {
      e.stopPropagation();
    }
  };

  return (
    <>
      {/* EXACT SAME LAYOUT AS LOGIN PAGE */}
   <main className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
  <section className="w-full max-w-md bg-white rounded-2xl shadow-lg p-4 border border-gray-200">

    <h2 className="text-xl font-bold text-center mb-1 text-green-700">
      Contact Us
    </h2>

    <p className="text-gray-600 mb-3 text-center text-sm">
      We'd love to hear from you
    </p>

    <form onSubmit={handleSubmit} className="space-y-3">

      {/* Name */}
      <div>
        <label className="block text-gray-700 text-sm mb-1">Name</label>
        <input
          type="text"
          value={form.name}
          onChange={handleChange("name")}
          disabled={status.sending}
          placeholder="John Doe"
          className="w-full p-2.5 rounded-lg bg-gray-100 border border-gray-300 focus:ring-2 focus:ring-green-500 text-sm"
        />
      </div>

      {/* Email */}
      <div>
        <label className="block text-gray-700 text-sm mb-1">Email</label>
        <input
          type="email"
          value={form.email}
          onChange={handleChange("email")}
          disabled={status.sending}
          placeholder="john@example.com"
          className="w-full p-2.5 rounded-lg bg-gray-100 border border-gray-300 focus:ring-2 focus:ring-green-500 text-sm"
        />
      </div>

      {/* Subject */}
      <div>
        <label className="block text-gray-700 text-sm mb-1">Subject</label>
        <input
          type="text"
          value={form.subject}
          onChange={handleChange("subject")}
          disabled={status.sending}
          placeholder="Your subject"
          className="w-full p-2.5 rounded-lg bg-gray-100 border border-gray-300 focus:ring-2 focus:ring-green-500 text-sm"
        />
      </div>

      {/* Message */}
      <div>
        <label className="block text-gray-700 text-sm mb-1">Message</label>
        <textarea
          value={form.message}
          onChange={handleChange("message")}
          rows="3"
          disabled={status.sending}
          placeholder="Write your message..."
          className="w-full p-2.5 rounded-lg bg-gray-100 border border-gray-300 focus:ring-2 focus:ring-green-500 resize-none text-sm"
        />
      </div>

      <button
        type="submit"
        disabled={status.sending}
        className="w-full bg-green-600 hover:bg-green-700 text-white py-2.5 rounded-lg text-sm font-semibold"
      >
        {status.sending ? "Sending..." : "Send via WhatsApp"}
      </button>

    </form>
  </section>
</main>


    </>
  );
}
